// extracted by mini-css-extract-plugin
module.exports = {"watchlistManagerTitleContainer":"sbN0Jenk","title":"cNsE1E0X","styledButton":"R6bj7zD_"};